<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Salesman"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = null)"
        @select="() => (state.params.q = null)"
        @change="(val) => emit('change', val, state.data.find(d => d.id === val))"
        v-bind="$attrs"
        :filter-option="false"
        :loading="state.loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="item in state.data" :key="item.id" :label="getLabel(item)">
            <span v-html="highlight(getLabel(item))"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { onMounted, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, keyBy, merge, pickBy, values } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        vendor_id: {
            type: [String, Number],
            default: () => null,
        },
        useram_id: {
            type: [String, Number],
            default: () => null,
        },
        is_total_toko: {
            type: [Boolean],
            default: () => false,
        },
        joinOptions: {
            type: [Array],
            default: () => [],
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: `/api/filter/salesman`,
            loading: false,
            data: [],
            params: {
                q: '',
                vendor_id: props.vendor_id,
                useram_id: props.useram_id,
                is_total_toko: props.is_total_toko,
            },
        })

        const fetchData = () => {
            state.loading = true
            apiClient.get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    const options = props.joinOptions.filter(item => item.id !== undefined)
                    if (options.length > 0) {
                        data = values(merge(keyBy(options, 'id'), keyBy(data, 'id')))
                    }
                    state.data = data
                })
                .finally(() => {
                    state.loading = false
                })
        }

        const fetchInitialById = (id) => {
            apiClient.get(state.endpoint, { params: pickBy({ ...state.params, q: id }) })
                .then(({ data }) => {
                    state.data = values(merge(keyBy(state.data, 'id'), keyBy(data, 'id')))
                    const found = state.data.find(d => d.id === id)
                    if (found) emit('change', id, found)
                })
        }

        const getLabel = (item) => {
            let label = item.id + ' - ' + item.name
            if (props.is_total_toko) {
                label += ` - (Toko: ${item.customer_count || 0})`
            }
            return label
        }

        onMounted(() => {
            if (props.value && !Array.isArray(props.value)) {
                fetchInitialById(props.value)
            }
            fetchData()
        })

        watch(() => props.vendor_id, () => {
            state.params.vendor_id = props.vendor_id
        })

        watch(() => props.useram_id, () => {
            state.params.useram_id = props.useram_id
        })

        watch(state.params, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = value => {
            state.params.q = value
        }

        const highlight = value => {
            if (!state.params.q) return value
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            state,
            emit,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            getLabel,
        }
    },
}
</script>
